var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SafeVerifyModal',{attrs:{"smstype":4},on:{"on-ok":_vm.confirmHandle},model:{value:(_vm.modalVis.loginPassVerify),callback:function ($$v) {_vm.$set(_vm.modalVis, "loginPassVerify", $$v)},expression:"modalVis.loginPassVerify"}})
}
var staticRenderFns = []

export { render, staticRenderFns }